export default __webpack_public_path__ + "static/media/arrowRight.7f22b5e0.svg";